import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=d5729a86&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5729a86')) {
      api.createRecord('d5729a86', component.options)
    } else {
      api.reload('d5729a86', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=d5729a86&", function () {
      api.rerender('d5729a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2LXIs7RWkkWWf/JS/pricehelp.vue"
export default component.exports